export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

function isLocalHostname(hostname) {
  const normalized = String(hostname || '')
    .trim()
    .toLowerCase();
  return (
    normalized === 'localhost' ||
    normalized === '127.0.0.1' ||
    normalized === '0.0.0.0' ||
    normalized.endsWith('.localhost')
  );
}

function normalizeApiBaseUrl(rawValue) {
  const configured = String(rawValue || '').trim();
  if (!configured) {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }

  try {
    const parsed = new URL(configured);

    if (typeof window !== 'undefined') {
      const pageUrl = new URL(window.location.href);
      const backendIsLocal = isLocalHostname(parsed.hostname);
      const pageIsLocal = isLocalHostname(pageUrl.hostname);
      const mixedLocalhostOnRemotePage = backendIsLocal && !pageIsLocal;
      const insecureHttpFromSecurePage =
        pageUrl.protocol === 'https:' && parsed.protocol === 'http:';

      if (mixedLocalhostOnRemotePage || (backendIsLocal && insecureHttpFromSecurePage)) {
        return pageUrl.origin;
      }
    }

    return parsed.origin;
  } catch {
    return configured.replace(/\/+$/, '');
  }
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_BACKEND_URL);
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
